import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_EFFICIENCY].GET_REPORTS_FINANCE_EFFICIENCY]: {
		url: '/company/:companyId/reports/finance/efficiency/',
	},
}
